export enum StationSelectionLevel {
  NONE = 'NONE', STATION_GROUP = 'STATION_GROUP', STATION_SET = 'STATION_SET', STATION = 'STATION'
}
